import { render, staticRenderFns } from "./SocialMediaButtons.vue?vue&type=template&id=b762ea78&scoped=true"
import script from "./SocialMediaButtons.vue?vue&type=script&lang=ts"
export * from "./SocialMediaButtons.vue?vue&type=script&lang=ts"
import style0 from "./SocialMediaButtons.vue?vue&type=style&index=0&lang=scss"
import style1 from "./SocialMediaButtons.vue?vue&type=style&index=1&id=b762ea78&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b762ea78",
  null
  
)

export default component.exports